(function () {
  var loader = document.getElementById('PageLoader');
  if (!loader) return;

  var MIN_VISIBLE_MS = 350;

  function hideLoader() {
    loader.classList.add('page-loader--hidden');
  }

  function showLoader() {
    loader.classList.remove('page-loader--hidden');
  }

  // Hide once the page has finished loading, but always let it show for
  // at least a moment so it reads as an intentional brand transition
  // rather than a flash.
  window.addEventListener('load', function () {
    setTimeout(hideLoader, MIN_VISIBLE_MS);
  });

  // Show it again the instant the user navigates away — covers link
  // clicks, back/forward, form submits, everything, without needing to
  // intercept individual links.
  window.addEventListener('pagehide', showLoader);

  // Pages restored from the back/forward cache don't fire "load" again,
  // so hide it manually in that case.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      setTimeout(hideLoader, MIN_VISIBLE_MS);
    }
  });
})();
